// Centralized formatting helpers. All dates render as strict YYYY-MM-DD.
// Signatures render the user's name + UTC timestamp for audit-trail clarity.

const TZ_OFFSET_MIN = new Date().getTimezoneOffset();

function pad(n) { return String(n).padStart(2, "0"); }

/**
 * Format any date-ish value (ISO, Date, "YYYY-MM-DD") to YYYY-MM-DD.
 * Returns empty string for falsy/invalid input.
 */
export function formatDate(input) {
  if (!input) return "";
  if (typeof input === "string" && /^\d{4}-\d{2}-\d{2}$/.test(input)) return input;
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return "";
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** Format as YYYY-MM-DD HH:mm (24h, local). */
export function formatDateTime(input) {
  if (!input) return "";
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return "";
  return `${formatDate(d)} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** Format an audit signature: "Signed by Jane Doe · 2026-02-14 14:32". */
export function formatSignature(name, when) {
  if (!name) return "";
  const stamp = when ? ` · ${formatDateTime(when)}` : "";
  return `Signed by ${name}${stamp}`;
}

/** Risk band given a 1-25 score from likelihood × severity. */
export function riskBand(score) {
  if (!score && score !== 0) return null;
  const s = Number(score);
  if (s <= 4) return { key: "low", label: "Low", color: "#1a8754" };
  if (s <= 9) return { key: "medium", label: "Medium", color: "#d6a900" };
  if (s <= 15) return { key: "high", label: "High", color: "#ff5f15" };
  return { key: "critical", label: "Critical", color: "#ff4500" };
}

/** Five-whys required threshold (score >= 12 = high or critical). */
export const FIVE_WHYS_THRESHOLD = 12;

void TZ_OFFSET_MIN; // retain symbol if needed in future
